import { SearchProps } from 'antd/es/input';
import { ContainerInputSearch } from './styles';
import { Input } from 'antd';

const { Search } = Input;

export const AInputSearch: React.FC<SearchProps> = ({ ...res }) => {
  return (
    <ContainerInputSearch>
      <Search {...res} />
    </ContainerInputSearch>
  );
};
